import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from "@angular/core";
import { FitTextDirective } from "../../../directives/fit-text/fit-text";
import { NgIf } from "@angular/common";

@Component({
    selector: "app-verification-badge",
    templateUrl: "./verification-badge.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, FitTextDirective],
})
export class VerificationBadgeComponent implements OnInit {
  /**
   * The model of the badge.
   */
  @Input() model: any;

  /**
   * The size of the badge.
   */
  @Input() size: number = 12;

  /**
   * Create a new instance of the component.
   */
  constructor() {}

  /**
   * On component init.
   */
  ngOnInit(): void {}
}
